<template>
    <v-dialog
        v-model="showCreateIndicator"
        v-if="showCreateIndicator"
        persistent
        max-width="800"
    >
        <validation-observer v-slot="{ handleSubmit }">
            <div class="indicator-create-wrapper">
                <div class="indicator-create-header">
                    <span v-if="isCreateIndicator" class="indicator-create-name">
                        TẠO BỘ CHỈ SỐ
                    </span>
                    <span v-else class="indicator-create-name">
                        SỬA BỘ CHỈ SỐ
                    </span>
                    <v-icon
                        size="24"
                        @click="closeModal"
                    >
                        mdi-close
                    </v-icon>
                </div>
                <div class="indicator-create-form">
                    <div class="input-form">
                        <div class="indicator-create-label pt-3">
                            Nhóm chỉ số *
                        </div>
                        <div class="input-wrapper col py-0 px-7">
                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Tên Nhóm chỉ số"
                            >
                                <v-autocomplete
                                    :items="groupList"
                                    item-text="name"
                                    item-value="id"
                                    class="indicator-create-input"
                                    placeholder="Chọn nhóm chỉ số..."
                                    v-model="indicator.groupId"
                                    :error-messages="errors"
                                    readonly
                                />
                            </validation-provider>
                        </div>
                    </div>
                    <div class="input-form">
                        <div class="indicator-create-label pt-3">
                            Tên bộ chỉ số *
                        </div>
                        <div class="input-wrapper col py-0 px-7">
                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Tên Bộ chỉ số"
                            >
                                <v-text-field
                                    class="indicator-create-input"
                                    placeholder="Nhập tên bộ chỉ số..."
                                    v-model="indicator.name"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </div>
                    </div>
                    <div class="input-form">
                        <div class="indicator-create-label pt-3">
                            Đơn vị đo *
                        </div>
                        <div class="input-wrapper col py-0 px-7">
                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Đơn vị đo"
                            >
                                <v-text-field
                                    class="indicator-create-input"
                                    placeholder="Nhập đơn vị đo..."
                                    v-model="indicator.unitName"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </div>
                    </div>
                    <div class="input-form">
                        <div class="indicator-create-label pt-3">
                            Status *
                        </div>
                        <div class="input-wrapper col py-0 px-7">
                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Status"
                            >
                                <v-autocomplete
                                    class="indicator-create-input"
                                    :items="statusList"
                                    placeholder="Chọn status..."
                                    v-model="indicator.status"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </div>
                    </div>
                </div>
                <div class="col text-center">
                    <button
                        class="cancel-btn"
                        @click="closeModal"
                    >
                        BỎ QUA
                    </button>
                    <button
                        class="accept-btn"
                        @click="handleSubmit(saveIndicator)"
                    >
                        LƯU
                    </button>
                </div>
            </div>
        </validation-observer>
    </v-dialog>
</template>

<script>
export default {
    props: {
        showCreateIndicator: {
            type: Boolean,
            default: false
        },
        indicator: {
            type: Object,
            default: () => {}
        },
        isCreateIndicator: {
            type: Boolean,
            default: true
        },
        groupList: {
            type: Array,
            default: () => {[]}
        },
        allowAcceptIndicator: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            statusList: ['Auto', 'Manual']
        }
    },

    methods: {
        closeModal() {
            Bus.$emit('close-indicator-create-modal')
        },

        saveIndicator() {
            if (this.allowAcceptIndicator) {
                Bus.$emit('action-save-indicator')
                Bus.$emit('save-indicator', this.indicator)
            }
        }
    }
}
</script>

<style scoped>
.indicator-create-wrapper {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.1);
}

.indicator-create-header {
    padding: 15px 0px;
    margin: 0px 20px 0px 30px;
    border-bottom: 1px solid #E0E0E0;
}

.indicator-create-header i {
    float: right;
    cursor: pointer;
}

.indicator-create-name {
    font-size: 20px;
    font-weight: 600;
}

.indicator-create-label {
    font-size: 16px;
    width: 20%;
}

.input-form {
    display: flex;
    width: 100%;
    padding: 10px 20px 25px 30px;
}

.input-wrapper {
    height: 48px;
}

.indicator-create-input {
    width: 100%;
    background-color: #F8F8F8;
    height: 100%;
    padding: 5px 20px;
    font-size: 16px;
    outline: unset;
    border-radius: 8px;
}

.indicator-create-add {
    width: 48px;
    height: 48px;
    background-color: white;
    border: 1px dashed #BDBDBD;
    border-radius: 8px;
}

.indicator-create-add i {
    color: black;
    font-size: 24px;
}

.cancel-btn {
    background-color: #F2F2F2;
    width: 192px;
    height: 56px;
    font-size: 16px;
    color: #828282;
    font-weight: 700;
    border-radius: 8px;
    margin-right: 24px;
}

.accept-btn {
    background-color: #7367F0;
    width: 192px;
    height: 56px;
    font-size: 16px;
    color: white;
    font-weight: 700;
    border-radius: 8px;
}
</style>